import React, { useEffect, useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// material-ui icons
// import Person from "@material-ui/icons/Person";
// import Edit from "@material-ui/icons/Edit";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import RichTextEditor from "react-rte";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "components/CustomButtons/Button.js";
import Switch from "@material-ui/core/Switch";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
} from "@material-ui/core";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
//import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import axios from "../../utils/axiosInstance"; 
import Edit from "@material-ui/icons/Edit";
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";

const useStyles = makeStyles(styles);

export default function AddTemplate() {
  const classes = useStyles();
  const [users, setUsers] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [text, setText] = useState("Default Template");
  const [emailBody, setEmailBody] = useState(RichTextEditor.createEmptyValue());
  const [smsBody, setSmsBody] = useState(RichTextEditor.createEmptyValue());
  const [emailSubject, setEmailSubject] = useState("");
  const [statusEmail, setStatusEmail] = useState(false);
  //const [statusSms, setStatusSms] = useState(false);
  const [rows, setRows] = useState([
    { id: 1, name: "John Doe", age: 25 },
    { id: 2, name: "Jane Smith", age: 30 },
    { id: 3, name: "Bob Johnson", age: 35 },
  ]);

  const [globalRows, globalSetRows] = useState([
    { id: 1, name: "John Doe", age: 25 },
    { id: 2, name: "Jane Smith", age: 30 },
    { id: 3, name: "Bob Johnson", age: 35 },
  ]);

  const handleEditorChange = (newValue) => {
    setEmailBody(newValue);
    newValue.toString("html");
  };

  const handleSmsEditorChange = (newValue) => {
    setSmsBody(newValue);
    newValue.toString("html");
  };

  const handleCellChangeGlobal = (event, id, field) => {
    const updatedRows = [...globalRows];
    const updatedRow = updatedRows.find((row) => row.id === id);
    updatedRow[field] = event.target.value;
    globalSetRows(updatedRows);
  };

  const handleCellChange = (event, id, field) => {
    const updatedRows = [...rows];
    const updatedRow = updatedRows.find((row) => row.id === id);
    updatedRow[field] = event.target.value;
    setRows(updatedRows);
  };

  const handleClick = () => {
    setIsEditing(true);
  };

  const handleChange = (event) => {
    setText(event.target.value);
  };

  const handleBlur = () => {
    setIsEditing(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const token = localStorage.getItem("token");
    console.log(token);
    await axios
      .get(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/notification`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        console.log(users);
        setUsers(res.data.data);
      })

      .catch((err) => {
        console.log(err);
        if(err.response.data.message=="For security reasons, we locked your account.Please login to continue"){
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        }
      });
  };
  //   const token = localStorage.getItem("token");
  //   console.log(userId);
  //   if (confirm("Are you sure you want to delete")) {
  //     await axios
  //       .delete(
  //         `https://cryptolotteryapi.dev.vinove.com/api/v1/admin/removeusers?userId=${userId}&userType=${userType}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             "Access-Control-Allow-Origin": "*",
  //           },
  //         },
  //         {
  //           userId,
  //           userType,
  //         }
  //       )
  //       .then((data) => {
  //         console.log(data);
  //         alert("You have successfully deleted!!");
  //         getData();
  //       })
  //       .catch(() => {
  //         //remove after working
  //         alert("Server Error");
  //       });
  //   } else {
  //     alert("Details are not deleted");
  //   }
  // };

  const handleAddRow = () => {
    const newRow = {
      id: rows.length + 1,
      name: "",
      age: 0,
    };
    setRows([...rows, newRow]);
  };
  const handleSubmit = async () => {
    try {
      const token = localStorage.getItem("token");
      const payload = {
        templateName: "BAL_ADD",
        shortCodesDescription: [
          {
            shortCode: "BAL_ADD",
            description: "Balance added",
          },
        ],
        globalShortCodes: {
          shortCode: "BAL_ADD",
          description: "Balance added",
        },
        emailTemplate: {
          subject: emailSubject,
          message: emailBody.toString("html"),
          status: statusEmail,
        },
        smsTemplate: {
          message: smsBody.toString("html"),
          status: true,
        },
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/notification`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      console.log("API response:", response.data);
      // Handle the response data here
      setIsEditing(true);
    } catch (error) {
      console.error("API error:", error);
      if(error?.response?.data?.message=="For security reasons, we locked your account.Please login to continue"){
        localStorage.removeItem("token");
        window.location.assign("/auth/login-page");
      }
      // Handle any errors that occurred during the API call
    }
  };

  return (
    <>
      <GridContainer>
        <GridItem xs={12} style={{ marginBottom: "15px" }}>
          <div onClick={handleClick}>
            {isEditing ? (
              <CustomInput
                value={text}
                onChange={handleChange}
                onBlur={handleBlur}
                autoFocus
                fullWidth
              />
            ) : (
              <div>
                {text} <Edit />
              </div>
            )}
          </div>
        </GridItem>
        <GridItem xs={12}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead
                style={{ backgroundColor: "#3C37FF", color: "#fffff" }}
              >
                <TableRow>
                  <TableCell style={{ color: "#ffffff" }}>Short Code</TableCell>
                  <TableCell style={{ color: "#ffffff" }}>
                    Description
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell>
                      <TextField
                        value={row.name}
                        onChange={(event) =>
                          handleCellChange(event, row.id, "name")
                        }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        value={row.age}
                        onChange={(event) =>
                          handleCellChange(event, row.id, "age")
                        }
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </GridItem>
      </GridContainer>
      <Button onClick={handleAddRow}>Add New Default Template</Button>
      <GridContainer style={{ marginTop: "35px" }}>
        <GridItem xs={12} style={{ marginBottom: "15px" }}>
          <div>Global Template Code</div>
        </GridItem>
        <GridItem xs={12}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Short Code</TableCell>
                  <TableCell>Description</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {globalRows.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell>
                      <TextField
                        value={row.name}
                        onChange={(event) =>
                          handleCellChangeGlobal(event, row.id, "name")
                        }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        value={row.age}
                        onChange={(event) =>
                          handleCellChangeGlobal(event, row.id, "age")
                        }
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </GridItem>
      </GridContainer>
      <GridContainer style={{ marginTop: "35px" }}>
        <GridItem xs={5} component={Paper} justify="space-between">
          <GridContainer container>
            <GridItem
              xs={12}
              style={{
                height: "40px",
                background: "#3C37FF",
                color: "#ffffff",
                display: "flex",
                alignItems: "center",
                marginBottom: "30px",
              }}
            >
              Email Template
            </GridItem>
            <GridItem item xs={8}>
              <CustomInput
                labelText="Subject"
                id="emailSubject"
                value={emailSubject}
                handleChange={(e) => setEmailSubject(e.target.value)}
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  type: "text",
                }}
              />
            </GridItem>
            <GridItem item xs={4}>
              <div className={classes.block}>
                <legend>Status</legend>
                <FormControlLabel
                  control={
                    <Switch
                      checked={statusEmail}
                      onChange={(event) => setStatusEmail(event.target.checked)}
                      value="checkedA"
                      classes={{
                        switchBase: classes.switchBase,
                        checked: classes.switchChecked,
                        thumb: classes.switchIcon,
                        track: classes.switchBar,
                      }}
                    />
                  }
                  classes={{
                    label: classes.label,
                  }}
                />
              </div>
            </GridItem>
            <GridItem xs={12}>
              <RichTextEditor
                value={emailBody}
                onChange={handleEditorChange}
                style={{ height: "300px" }}
              />
            </GridItem>
          </GridContainer>
        </GridItem>
        <GridItem
          xs={5}
          component={Paper}
          style={{ height: "500px", p: "20px", marginleft: "20px" }}
        >
          <GridContainer container>
            <GridItem
              xs={12}
              style={{
                height: "40px",
                background: "#3C37FF",
                color: "#ffffff",
                display: "flex",
                alignItems: "center",
                marginBottom: "30px",
              }}
            >
              SMS Template
            </GridItem>
            <GridItem item xs={8}>
              <CustomInput
                labelText="Subject"
                id="emailSubject"
                value={emailSubject}
                handleChange={(e) => setEmailSubject(e.target.value)}
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  type: "text",
                }}
              />
            </GridItem>
            <GridItem item xs={4}>
              <legend>Status</legend>
              <div className={classes.block}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={statusEmail}
                      onChange={(event) => setStatusEmail(event.target.checked)}
                      value="checkedA"
                      classes={{
                        switchBase: classes.switchBase,
                        checked: classes.switchChecked,
                        thumb: classes.switchIcon,
                        track: classes.switchBar,
                      }}
                    />
                  }
                  classes={{
                    label: classes.label,
                  }}
                />
              </div>
            </GridItem>
            <GridItem xs={12}>
              <RichTextEditor
                value={smsBody}
                onChange={handleSmsEditorChange}
                style={{ height: "300px" }}
              />
            </GridItem>
          </GridContainer>
        </GridItem>
        <GridItem>
          <Button
            color="#3C37FF"
            style={{ float: "right" }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </GridItem>
      </GridContainer>
    </>
  );
}
